import React, { Fragment, useState } from 'react'
import estilos from '../Zonas/ZonasListComponent.module.css'
import LocalidadesDeLaZonaListComponent from './LocalidadesDeLaZonaListComponent';
import MapaComponent from './MapaComponent';
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import LocalidadFormComponent from './LocalidadFormComponent'
import { getLocalidadesByZona } from "../../../redux/DucksUnidadInspeccion/ZonasDuck";


function LocalidadesDeLaZonaComponent(props) {

    /* @refresh reset */
    const zona = props.zona
    const dispatch = useDispatch()
    const localidades = props.localidades
    const sublocalidades = props.sublocalidades

    const [localidadModify, setLocalidadModify] = React.useState(null)

    const [modalAnadirLocalidad, setOpenModalAnadirLocalidad] = React.useState(false);

    React.useEffect(() => {
        zona
    }, [zona])

    React.useEffect(() => {
        localidades
    }, [localidades])

    React.useEffect(() => {
        sublocalidades
    }, [sublocalidades])

    const handleOpenModalAnadirLocalidad = () => setOpenModalAnadirLocalidad(true);

    const handleCloseModalAnadirLocalidad = () => {
        setOpenModalAnadirLocalidad(false);
        setLocalidadModify(null)
    }

    const handleEditarLocalidad = (localidad) => {
        handleOpenModalAnadirLocalidad()
        setLocalidadModify(localidad)
    }

    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1500, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };


    const HTMLmodalAnadirLocalidades = () => {
        return (
            <Modal
                open={modalAnadirLocalidad}
                onClose={handleCloseModalAnadirLocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>

                    <LocalidadFormComponent localidadModify={localidadModify} handleClose={props.handleClose} onClose={handleCloseModalAnadirLocalidad} actualizarZonas={props.actualizarZonas} zona={zona}></LocalidadFormComponent>
                </Box>
            </Modal >
        )
    }

    return (
        <Fragment><br />
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-2`}>
                <div className='row'>
                    <div className='col-8' style={{ textAlign: 'left' }}>
                        <h3 className={`${estilos.tituloForm}`}>Lista de Localidades de ({zona.nombrezona})</h3>
                    </div>
                    <div className='col-4' style={{ textAlign: 'right' }}>
                        {/* <button onClick={handleOpenModalAnadirLocalidad} className='btn btn-success'>Añadir Localidad</button> */}

                    </div>
                </div>
                <hr></hr>
                <div className='row' >
                    <div className='col-8' style={{ textAlign: 'left' }}>
                        <div style={{ height: '100vh', width: '100%' }}>
                            {<MapaComponent localidades={localidades} lat={19.4978} lng={-99.1269} zoom={6} tipo={1}></MapaComponent>}
                        </div>
                    </div>
                    <div className='col-4 mt-3' style={{ textAlign: 'center' }} >
                        <div>
                            {
                                localidades.length > 0 ? (<></>) : (<h1><strong>Sin localidades</strong></h1>)
                            }
                            <LocalidadesDeLaZonaListComponent actualizarZonas={props.actualizarZonas} handleClose={props.handleClose} onEditarLocalidad={handleEditarLocalidad} key={zona.idzona + '1-1'} localidades={localidades} zona={zona}></LocalidadesDeLaZonaListComponent>
                        </div>
                    </div>
                </div>
            </div>

            {HTMLmodalAnadirLocalidades()}

        </Fragment>
    )
}

export default LocalidadesDeLaZonaComponent